import { AwsRum } from 'aws-rum-web';
import config from './config';
import packageJson from '../package.json';

// Single AwsRum instance for the app. Null until initRum() runs, and only
// non-null in an environment whose config carries the rum* fields.
let awsRum = null;

// Initialize CloudWatch RUM.
//
// Activation is gated purely on the presence of the rum* config fields that a
// FrontendStack with RUM enabled writes into config.json at deploy time — not
// on `mode`. This way any environment lights up as soon as its RUM infra exists
// and its values are injected (staging today, production when enabled), with no
// client change needed to promote staging → production. Environments without
// those fields stay dark. Safe to call more than once and never throws — a RUM
// failure must not break app boot.
export function initRum() {
  if (awsRum) {
    return awsRum;
  }

  if (!config.rumApplicationId || !config.rumIdentityPoolId) {
    return null;
  }

  try {
    awsRum = new AwsRum(config.rumApplicationId, packageJson.version || '1.0.0', config.rumRegion, {
      // Injected per environment (staging 1.0, production reduced for cost).
      // Falls back to full capture when config omits it.
      sessionSampleRate: config.rumSessionSampleRate ?? 1,
      identityPoolId: config.rumIdentityPoolId,
      guestRoleArn: config.rumGuestRoleArn,
      endpoint: `https://dataplane.rum.${config.rumRegion}.amazonaws.com`,
      telemetries: ['errors', 'performance', 'http'],
      allowCookies: false,
      enableXRay: false,
    });
  } catch (err) {
    // Swallow: RUM is best-effort telemetry, not a hard dependency of the app.
    awsRum = null;
  }

  return awsRum;
}

// Returns the initialized AwsRum instance, or null if RUM is inactive
// (no rum* config for this environment, or init failed). Consumers must handle null.
export function getRum() {
  return awsRum;
}
